import * as Mutations from "@/store/mutations.type";

export default {
  [Mutations.SET_INSTANCE_PAGE](state, page) {
    state.page = page;
  },
  [Mutations.SET_DATA_LOADING](state, loading) {
    state.loading = loading;
  },
  [Mutations.SET_SYNC_DATA_FETCH_LOADING](state, { region, loading }) {
    state.syncDataFetchLoading[region] = loading;
  },
  [Mutations.SET_INTRO_DATA_LOADING](state, loading) {
    state.introLoading = loading;
  },
  [Mutations.SET_DATA_ERROR](state, errors) {
    state.errors = errors;
  },
  [Mutations.SET_DATA_SUCCESS](state, success) {
    state.success = success;
  },
  [Mutations.SET_INSTANCE_DESCRIPTION](state, { instanceId, description }) {
    state.description[instanceId] = description;
  },
  [Mutations.SET_BASIC_ATTRIBUTES](state, attributes) {
    let formatObject = {};
    if (attributes) {
      formatObject = JSON.parse(JSON.stringify(attributes));
      for (const item in formatObject) {
        if (formatObject[item].type === "long_text") {
          delete formatObject[item];
        }
      }
    }
    state.compBasicAttributes = formatObject;
  },
  [Mutations.SET_ADDITIONAL_ATTRIBUTES](state, attributes) {
    let formatObject = {};
    if (attributes) {
      formatObject = JSON.parse(JSON.stringify(attributes));
      for (const item in formatObject) {
        if (formatObject[item].type !== "long_text") {
          delete formatObject[item];
        }
      }
    }
    state.compAdditionalAttributes = formatObject;
  },
  [Mutations.SET_ALL_ATTRIBUTES](state, attributes) {
    if (attributes) {
      state.compAllAttributes = JSON.parse(JSON.stringify(attributes));
    } else {
      state.compAllAttributes = {};
    }
  },
  [Mutations.SET_INSTANCE_INFO](state, instanceInfo) {
    if (instanceInfo) {
      state.compInstanceInfo = instanceInfo;
    } else {
      state.compInstanceInfo = [];
    }
  },
  [Mutations.SET_SYNC_INSTANCE_INFO](state, { region, instanceInfo }) {
    if (instanceInfo) {
      state.syncCompInstanceInfo[region] = instanceInfo;
    } else {
      state.syncCompInstanceInfo[region] = [];
    }
  },
  [Mutations.SET_SYNC_LOADING](state, status) {
    state.syncLoading = status;
  },
  [Mutations.SET_INTRO_INSTANCE_INFO](state, instanceInfo) {
    if (instanceInfo) {
      state.compIntroInstanceInfo = instanceInfo;
    } else {
      state.compIntroInstanceInfo = [];
    }
  },
  [Mutations.REMOVE_INSTANCE_INFO](state, instanceId) {
    state.compInstanceInfo = state.compInstanceInfo
      .filter((item) => item.id !== instanceId)
      .reverse();
  },
  [Mutations.CLEAR_COMPONENT_INFO](state) {
    state.compInstanceInfo = [];
    state.compInstanceDraft = [];
    state.compBasicAttributes = null;
    state.compAdditionalAttributes = null;
  },
  [Mutations.SET_SAVE_LOADING](state, loading) {
    state.saveLoading = loading;
  },
  [Mutations.SET_COPY_LOADING](state, loading) {
    state.copyLoading = loading;
  },
  [Mutations.SET_CREATE_LOADING](state, loading) {
    state.createLoading = loading;
  },
  [Mutations.SET_DELETE_LOADING](state, { loading, index }) {
    state.deleteLoading[index] = loading;
  },
  [Mutations.SET_OPERATION_MODE](state, operation) {
    state.operation = operation;
  },
  [Mutations.RESET_OPERATION_MODE](state) {
    state.operation = "update";
  },
  [Mutations.SET_INSTANCE_SEARCH](state, search) {
    state.search = search;
  },

  // ********************* abi image slider *********************

  [Mutations.SET_SLIDE_INSTANCE](state, instance) {
    state.slideInstance = instance;
  },
  [Mutations.SET_SLIDE_ATTRIBUTES](state, attr) {
    state.slideAttributes = attr;
  },
  [Mutations.SET_SLIDE_LOADING](state, loading) {
    state.slideLoading = loading;
  },
  [Mutations.SET_SLIDER_CREATE_LOADING](state, loading) {
    state.sliderCreateLoading = loading;
  },
  [Mutations.SET_SLIDER_UPDATE_LOADING](state, loading) {
    state.sliderUpdateLoading = loading;
  },
  [Mutations.SET_SLIDER_COPY_LOADING](state, loading) {
    state.sliderCopyLoading = loading;
  },

  // ********************* global instance search ******************
  [Mutations.SET_GLOBAL_SEARCH_RESULT](state, result) {
    state.searchResult = result;
  },
  [Mutations.SET_GLOBAL_SEARCH_LOADING](state, status) {
    state.searchLoading = status;
  },

  // *********************  draft ******************

  [Mutations.SET_INSTANCE_DRAFT](state, instanceDraft) {
    if (instanceDraft) {
      state.compInstanceDraft = instanceDraft;
    } else {
      state.compInstanceDraft = [];
    }
  },
  [Mutations.SET_DRAFT_MODE_STATUS](state, status) {
    state.draftMode = status;
  },
  [Mutations.SET_DRAFT_SAVE_LOADING](state, status) {
    state.draftSaveLoading = status;
  },
  [Mutations.SET_DRAFT_CREATE_LOADING](state, status) {
    state.draftCreateSaveLoading = status;
  },
  [Mutations.REMOVE_DRAFT_INFO](state, draftId) {
    state.compInstanceInfo = state.compInstanceInfo
      .filter((item) => item.id !== draftId)
      .reverse();
  },
  // *********************  notice ******************

  [Mutations.SET_DELAY_MESSAGE](state, message) {
    state.delayMessage = message;
  },
  [Mutations.SET_DELAY_MESSAGE_LOADING](state, status) {
    state.delayMessageUpdateLoading = status;
  },
  [Mutations.SET_FETCH_DELAY_MESSAGE_LOADING](state, status) {
    state.delayMessageFetchLoading = status;
  }
};
